import {requestHelpers} from '../../helpers';

const actions = {
    GET_COUNTRIES: 'GET_COUNTRIES',
    SET_COUNTRIES: 'SET_COUNTRIES'
};

function getCountries() {

    return (dispatch) => {
        // dispatch({
        //     type: actions.GET_COUNTRIES,
        // });

        requestHelpers.authenticatedGetRequest('/common/locations/countries')
            .then((response) => {
                dispatch({
                    type: actions.SET_COUNTRIES,
                    countries: response.data,
                });
            });
    }
}

module.exports = {
    actions,
    getCountries
};



// WEBPACK FOOTER //
// src/client/actions/common/countries.js